<div class="campanha-lead-view">
    <div class="card">
        <div class="card-header">
            <sgt-campanha-lead-filter
                [idCampanha]="idCampanha"
                [filter]="filter"
                (filterChange)="onFilterChange()">
            </sgt-campanha-lead-filter>
        </div>
 
        <div class="card-body">
            <sgt-lead-table
                #leadTable
                [filter]="filter"
                [optionsVisibility]="{
                    canEdit: false,
                    canDelete: false,
                    canInsertNegocio: false
                }">
            </sgt-lead-table>
        </div>
    </div>
</div>
